/**
 * 圖片上傳共用工具（僅供瀏覽器端使用，依賴 Canvas / Image）
 * 專案內所有圖上傳應使用此轉檔邏輯，以統一縮小尺寸與 WebP 壓縮。
 */
/** 轉檔後最長邊最大寬度（px） */
export const IMAGE_UPLOAD_MAX_WIDTH = 800;
/** 轉檔後最長邊最大高度（px） */
export const IMAGE_UPLOAD_MAX_HEIGHT = 600;
/** WebP 品質 0–1 */
export const IMAGE_UPLOAD_WEBP_QUALITY = 0.8;
/**
 * 將圖片縮小並轉成 WebP（前端轉檔，減小檔案）
 * @param file 原始圖片檔
 * @param options 可選：maxWidth, maxHeight, quality
 * @returns WebP 格式的 File
 */
export function convertToWebP(file, options) {
    const maxWidth = options?.maxWidth ?? IMAGE_UPLOAD_MAX_WIDTH;
    const maxHeight = options?.maxHeight ?? IMAGE_UPLOAD_MAX_HEIGHT;
    const quality = options?.quality ?? IMAGE_UPLOAD_WEBP_QUALITY;
    return new Promise((resolve, reject) => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        const img = new Image();
        img.onload = () => {
            let { width, height } = img;
            if (width > height) {
                if (width > maxWidth) {
                    height = (height * maxWidth) / width;
                    width = maxWidth;
                }
            }
            else {
                if (height > maxHeight) {
                    width = (width * maxHeight) / height;
                    height = maxHeight;
                }
            }
            canvas.width = width;
            canvas.height = height;
            ctx?.drawImage(img, 0, 0, width, height);
            canvas.toBlob(blob => {
                if (blob) {
                    resolve(new File([blob], file.name.replace(/\.[^/.]+$/, '.webp'), {
                        type: 'image/webp',
                        lastModified: Date.now(),
                    }));
                }
                else {
                    reject(new Error('無法轉換圖片格式'));
                }
            }, 'image/webp', quality);
        };
        img.onerror = () => reject(new Error('無法載入圖片'));
        img.src = URL.createObjectURL(file);
    });
}
